import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Trigger } from '../../models/trigger';
import { Observable, of } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

export class TriggerDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.TRIGGER, apiHelper);
  }

  public serverUpdate(trigger): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/' + trigger.id;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'PUT', null, trigger, headers);
  }
}
